export default "__VITE_ASSET__DVfCU6Mh__"